export default "__VITE_ASSET__CrWRJWXt__"